module.exports = __webpack_public_path__ + "images/alert-bell-red-95d51636.svg";